import React, { useContext, useEffect } from "react";
import DisplayChannelStyles from "../../Styles/ChannelViewer/DisplayChannel.module.css";
import { ContextForClient } from "../../Context_file/ClientContext";
import { fetchRequest } from "../../helper/CustomFetch";
import Lists from "../../Common/List.component/List";
import Image from "../../Common/Image.component/Image";

const FetchChannelUSers = () => {
  const [{ channelName, channelMember }, dispatch] =
    useContext(ContextForClient);
  const { wrapper, id, names, idImg } = DisplayChannelStyles;

  useEffect(() => {
    const url = `channelmembers?channel=${channelName}`,
      storage = "channelMember";
    fetchRequest({ url, storage, dispatch });
  }, [dispatch, channelName]);

  const channelMembers =
    channelMember && channelMember ? (
      <nav className="list-group">
        {channelMember.map(({ firstName, lastName, profileImage }, index) => {
          let twoLetter =
            firstName && `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`;
          return (
            <div key={index} className={` d-flex ${wrapper}`}>
              {profileImage ? (
                <Image src={profileImage} alt={lastName} className={idImg} />
              ) : (
                <Lists
                  text={<span>{twoLetter.toUpperCase()}</span>}
                  listStyle="none"
                  className={id}
                  color="#aaa"
                />
              )}

              <Lists
                text={`${firstName} ${lastName}`}
                key={index}
                listStyle="none"
                className={`text-capitalize ${names}`}
                color="#aaa"
              />
            </div>
          );
        })}
      </nav>
    ) : (
      <div>
        <h2>nothing found</h2>
      </div>
    );
  return (
    <div className="container w-100">
      <h2 className="text-uppercase" style={{ color: "#fff" }}>
        {channelMember.length > 1 ? "members" : "member"}
      </h2>
      {channelMembers}
    </div>
  );
};

export default FetchChannelUSers;
